/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Row,
  Tabs,
} from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';
import SeguridadSocialAsig from './SeguridadSocialAsig';
import SeguridadSocialAsigNominaEmpleado from './SeguridadSocialAsigNominaEmpleado';
import SeguridadSocialCambios from './SeguridadSocialCambios';

export const AsignacionSegSocialPermission = {
  permissionModel: 'justificacionrelojchecador',
  catalogsModels: [],
  tabsModels: [],
};

const AsignacionSegSocial = ({ permission }) => {
  const [currentParentTabKey, setCurrentParentTabKey] = useState('seguridad_social');

  return (
    <Row className="container">
      <Tabs
        type="card"
        activeKey={currentParentTabKey || 'seguridad_social'} // Evitar undefined
        onChange={setCurrentParentTabKey}
      >
        <TabPane
          tab={(
            <span>
              Seguridad Social
            </span>
          )}
          key="seguridad_social"
          forceRender
        >
          <SeguridadSocialAsig
            permission={permission}
          />
        </TabPane>
        <TabPane
          tab={(
            <span>
              Por Tipo de Nómina de Empleado
            </span>
          )}
          key="tipo_nomina_empleado"
        >
          <SeguridadSocialAsigNominaEmpleado
            permission={permission}
          />
        </TabPane>
        <TabPane
          tab={(
            <span>
              Cambios
            </span>
          )}
          key="cambios"
        >
          <SeguridadSocialCambios
            permission={permission}
          />
        </TabPane>
      </Tabs>
    </Row>
  );
};

export default AsignacionSegSocial;
